module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-greek29.f8a27a6.woff2";